import {useContext} from 'react';
import {MobileButton} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Mobile/MobileButton';
import {menuMappingKeys} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {FontIcon} from '~library/svg/FontIcon';
import {FontSizeIcon} from '~library/svg/FontSizeIcon';
import {KeyboardIcon} from '~library/svg/KeyboardIcon';
import {LineHeightIcon} from '~library/svg/LineHeightIcon';
import {TextColorIcon} from '~library/svg/TextColorIcon';
import {TextFormatIcon} from '~library/svg/TextFormatIcon';

export const TextEditorButtons = ({activeMenu, onKeyboardButtonClick, onClickMenu}) => {
  const {activeObjects} = useContext(EventCreateContext);

  return (
    <div className="card_editor--mobile__buttons">
      <MobileButton
        icon={<KeyboardIcon />}
        onClick={onKeyboardButtonClick}
        active={activeMenu === menuMappingKeys.KEYBOARD}
        title="Edit Text"
        dataQaId="step1-texteditor"
      />
      <MobileButton
        icon={<FontIcon />}
        onClick={onClickMenu(menuMappingKeys.FONT_STYLE)}
        title="Font"
        dataQaId="step1-textstyle"
      />
      <MobileButton
        icon={<FontSizeIcon />}
        onClick={onClickMenu(menuMappingKeys.FONT_SIZE)}
        title="Size"
        dataQaId="step1-textsize"
      />
      <MobileButton
        icon={<TextColorIcon color={activeObjects?.[0]?.fill} />}
        onClick={onClickMenu(menuMappingKeys.COLOR)}
        title="Color"
        dataQaId="step1-textcolor"
      />
      <MobileButton
        icon={<TextFormatIcon />}
        onClick={onClickMenu(menuMappingKeys.TEXT_FORMAT)}
        title="Format"
        dataQaId="step1-textformat"
      />
      <MobileButton
        icon={<LineHeightIcon />}
        onClick={onClickMenu(menuMappingKeys.SPACING)}
        title="Spacing"
        dataQaId="step1-textspacing"
      />
    </div>
  );
};
